function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t\t.st0{fill:none;}\n\t\t.st1{fill:#5768A8;}\n\t");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "spacer",
  className: "st0",
  width: 32,
  height: 32
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M29.9,2.1v10.8h-2V5.5L14.1,19.3l-1.4-1.4L26.4,4.1h-7.4v-2H29.9z M27.9,27.9H4.1V4.1h11.9v-2H5.1 c-1.7,0-3,1.3-3,3v21.8c0,1.7,1.3,3,3,3h21.8c1.7,0,3-1.3,3-3V16h-2V27.9z"
});

var SvgLinkExternal = function SvgLinkExternal(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkExternal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link-external.418a4a5a.svg";
export { ForwardRef as ReactComponent };